import React from 'react';
import { Map, Marker, TileLayer, Tooltip, GeoJSON } from 'react-leaflet'
import { mapUrl, getIconMarker } from '../../utils/map';
import { Input, Icon, message, Select } from 'antd';
import { OrganismService } from '../../services/config.service';
import { getCurrentUser, dmsToDecimalDegrees } from '../../utils/utils';
import { MUNICIPALITY, PARISH } from '../../utils/static-data';
import './coordinates-picker.scss';
import { guarico } from '../../utils/guarico';

const { Option } = Select;

class CoordinatesPicker extends React.Component {

  state = {
    position: null,
    mapPosition: { lat: 9.914405647821084, lng: -67.35683441162111 },
    parish: [],
    user: getCurrentUser(),
    name: "",
    saving: false
  }

  setMarker = (e) => {
    this.setState({ position: e.latlng });
  }


  renderMap = () => {
    const position = this.state.mapPosition;
    const map = (
      <Map center={position} zoom={13} onClick={this.setMarker}>
        <TileLayer
          url={mapUrl}
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        <GeoJSON key="guarico-limits" data={guarico} />
        {this.state.position &&
          <Marker icon={getIconMarker(1)} position={this.state.position}>
          </Marker>
        }
        {this.props.places.map(p => (
          <Marker icon={getIconMarker(4)} position={[p.lat, p.lng]}>
            <Tooltip>
              {p.name}
            </Tooltip>
          </Marker>
        ))}
      </Map>
    )
    return map;
  }

  savePlace = async () => {
    try {
      this.setState({ saving: true });
      const lat = this.state.position.lat;
      const lng = this.state.position.lng;
      const organism = this.state.user.organism;
      const name = this.state.name;
      if (!name) {
        this.setState({ saving: false });
        return message.error("Debe indicar el nombre del sitio");
      }
      const place = { lat, lng, organism, name };
      const savedPlace = await OrganismService.savePlace(place);
      this.setState({ saving: false });
      this.props.onSave(savedPlace);
    } catch (err) {
      message.error(err.toString());
      this.setState({ saving: false });
    }

  }

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  }

  municipalitySelected = (m) => {
    this.setState({
      parish: PARISH.filter(p => p.municipality === m)
    });
  }

  parishSelected = (p) => {
    const parish = this.state.parish[p];
    const mapPosition = { lat: dmsToDecimalDegrees(parish.lat) * 1, lng: (dmsToDecimalDegrees(parish.lng) * -1) };
    this.setState({ mapPosition });
  }

  render() {
    return (
      <div className="layout">
        <div className="item">
          {this.state.position && <span>Lat: {this.state.position.lat} Lng: {this.state.position.lng}</span>}
        </div>
        <div className="inputs">
          <Select placeholder="Municipio" onSelect={this.municipalitySelected} style={{ width: '33.33%' }}>
            {MUNICIPALITY.map((m, i) => (
              <Option key={i} value={m.id}>{m.name}</Option>
            ))}
          </Select>
          <Select placeholder="Parroquia" onSelect={this.parishSelected} style={{ width: '33.33%' }}>
            {this.state.parish.map((p, i) => (
              <Option key={i} value={i}>{p.name}</Option>
            ))}
          </Select>
          <Input style={{ width: '33.33%' }} placeholder="Nombre del lugar"
            value={this.state.name} onChange={this.handleNameChange}
            addonAfter={<Icon type={this.state.saving ? "loading" : "save"} onClick={this.savePlace} />} />
        </div>
        <div className="item">
          {this.renderMap()}
        </div>

      </div>
    )
  }
}

export default CoordinatesPicker;